import API from '@/views/Fdc/Apis/'
import Modal from '@/views/Fdc/EqpInfo/Components/Modal'

/**
 * EQP Info > Fab Manager
 * Fab 정보 관리 (Fab, Area, EQP Model)
 */
export default {
  name: 'FabManager',
  components: {
    'modal': Modal // Add 및 Edit Modal
  },
  beforeMount () {
    this.initColumns()
  },
  mounted () {
    this.listFn()

    /**
     * Excel import function
     */
    // let self = this
    // document.getElementById('importFileInput').addEventListener('change', function () {
    //   let fileInput = document.getElementById('importFileInput')
    //   if (fileInput.files[0]) {
    //     if (fileInput.files[0].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
    //       fileInput.files[0].type !== 'application/vnd.ms-excel.sheet.macroEnabled.12') {
    //       self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_FILE_EXTENSION', ['xlsx']))
    //       self.resetFileInput()
    //       return ''
    //     }

    //     let reader = new FileReader()
    //     reader.onload = function () {
    //       let workbook = new wjcXlsx.Workbook()
    //       workbook.loadAsync(reader.result, () => {
    //         let excelcell = workbook.sheets[0].rows[0]
    //         // Column 수 계산 (count로 계산)
    //         if (excelcell.cells.length === (self.fabManagerGrid.columns.length - 1)) {
    //           var count = 0
    //           // header 일치 여부 확인 (count로 계산)
    //           // row header column 빼고 계산
    //           for (var i = 0; i < self.fabManagerGrid.columns.length - 1; i++) {
    //             if (excelcell.cells[i].value === self.fabManagerGrid.columns[i + 1].header) {
    //               count++
    //             }
    //           }
    //           // header 일치 시 process start
    //           if (count === self.fabManagerGrid.columns.length - 1) {
    //             let newRowData = []
    //             for (let i = 0; i < workbook.sheets[0].rows.length - 1; i++) {
    //               let newRow = {}
    //               if (workbook.sheets[0].rows[i + 1].cells[0].value &&
    //                   workbook.sheets[0].rows[i + 1].cells[1].value &&
    //                   workbook.sheets[0].rows[i + 1].cells[2].value) {
    //                 newRow.fab = workbook.sheets[0].rows[i + 1].cells[0].value.toString()
    //                 newRow.line = workbook.sheets[0].rows[i + 1].cells[1].value.toString()
    //                 newRow.fabUseYn = workbook.sheets[0].rows[i + 1].cells[2].value.toString()
    //                 newRow.area = workbook.sheets[0].rows[i + 1].cells[3].value.toString()
    //                 newRow.vendor = workbook.sheets[0].rows[i + 1].cells[4].value.toString()
    //                 newRow.eqpModel = workbook.sheets[0].rows[i + 1].cells[5].value.toString()

    //                 newRow.isNew = true
    //                 newRow['_status'] = {}
    //                 newRow['_status']['checked'] = true
    //                 newRow['_status']['added'] = true
    //                 newRow['_status']['modified'] = false
    //                 newRowData.push(newRow)
    //               }
    //             }

    //             self.rowData = newRowData

    //             // ie 일때 input[type=file] init.
    //             self.resetFileInput()
    //           } else {
    //             self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_COLUMN'))
    //             self.resetFileInput()
    //           }
    //         } else {
    //           self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_NOT_VALID_COLUMN'))
    //           self.resetFileInput()
    //         }
    //       })
    //     }
    //     reader.readAsDataURL(fileInput.files[0])
    //   }
    // })
  },
  methods: {
    /**
     * Column initialize
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 110, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB') + ' ' + this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'fabUseYn', width: 120, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.LINE'), field: 'line', width: 110 },
        { headerName: this.$t('fdc.COMMON.COLUMN.AREA'), field: 'area', width: 110 },
        { headerName: this.$t('fdc.COMMON.COLUMN.AREA') + ' ' + this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'areaUseYn', width: 120, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.VENDOR'), field: 'vendor', width: 110 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_MODEL'), field: 'eqpModel', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODEL') + ' ' + this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'eqpModelUseYn', width: 120, hide: true }
      ]
    },
    /**
     * Fab Manager 목록 조회
     */
    async listFn () {
      let data = await API.BaseInfo.getFabs()
      this.rowData = data
    },
    /**
     * Fab Edit Modal 열기
     */
    rowEdit () {
      this.fabSaveModal.visible = true
      this.modalTitle = this.$t('fdc.EQP_INFO.TITLE.T0014')
      this.initEditModal()
    },
    /**
     * Fab Edit 초기 data 설정
     */
    initEditModal () {
      // const rows = this.$refs.fabManagerGrid.grid.rows.filter(row => row.dataItem._status)
      // const checkedRowData = rows.find(row => row.dataItem._status.checked).dataItem
      const checkedRowData = this.$refs.fabManagerGrid.gridApi.getSelectedRows()[0]
      checkedRowData.saveType = 'Edit'
      this.initValue = checkedRowData
    },
    /**
     * Fab Edit/Save Modal 닫기
     */
    closeFabSaveModel () {
      this.fabSaveModal.visible = false
    },
    /**
     * Fab Add/Edit Modal data 초기화
     */
    resetFabModal () {
      this.initValue = {}
    },
    /**
     * Fab Add Modal 열기
     */
    newRowAdd () {
      this.modalTitle = this.$t('fdc.EQP_INFO.TITLE.T0013')
      this.initValue = {
        saveType: 'Add'
      }
      this.fabSaveModal.visible = true
    },
    /**
     * Fab Manager Grid에 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRows () {
      // if (!this.$refs.fabManagerGrid) {
      //   return 0
      // }
      // return this.$refs.fabManagerGrid.checkedRowCount > 0
      if (!this.$refs.fabManagerGrid) {
        return 0
      }
      return this.$refs.fabManagerGrid.checkedRowCount > 0
    },
    /**
     * Fab Manager Grid에 check된 row count가 1개인지 확인
     * @returns {Boolean} check된 1개인지 여부
     * Edit 가능 여부에 대해서 판단하여 button 활성화 값이 달라집니다.
     */
    hasOneCheckedRow () {
      if (!this.$refs.fabManagerGrid) {
        return 0
      }
      return this.$refs.fabManagerGrid.checkedRowCount === 1
    },
    /**
     * Fab 삭제
     * check된 row에 대한 삭제를 진행합니다.
     */
    async deleteData () {
      let self = this
      // let allRows = this.$refs.fabManagerGrid.grid.rows
      // let checkedRows = common.getCheckedRows(allRows)
      const checkedRows = this.$refs.fabManagerGrid.gridApi.getSelectedRows()
      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
        return
      }

      let mustDeleteRows = []

      for (let i in checkedRows) {
        let isCreate = true
        if (!checkedRows[i].isNew) {
          isCreate = false
        }
        var data = checkedRows[i]
        if (!isCreate) {
          mustDeleteRows.push(data)
        }
      }

      let message = (mustDeleteRows.length) + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function deleteLastProcess (response) {
            if (response != null && response.data === true && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE'))
              self.listFn()
            } else if (response != null && response.data === false && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_DELETE_BY_EQP'))
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_DELETE'))
            }
          }

          if (mustDeleteRows.length > 0) {
            API.BaseInfo.saveFab(mustDeleteRows).then(result => {
              deleteLastProcess(result)
            })
          }
        },
        onCancel: function () {}
      })
    },
    /**
     * Excel Export
     * 조회된 결과를 Excel 파일로 저장합니다.
     */
    exportExcel () {
      // this.$refs.fabManagerGrid.exportExcel('FabManager')
      this.$refs.fabManagerGrid.gridApi.exportDataAsCsv({
        fileName: 'FabManager.csv'
      })
    },
    /**
     * Excel Import
     * excel을 import 할 수 있도록 파일 선택창을 띄웁니다.
     */
    importExcel () {
      this.resetFileInput()
      document.getElementById('importFileInput').click()
    },
    /**
     * File value 초기화
     * 선택된 파일을 초기화 합니다.
     */
    resetFileInput () {
      document.getElementById('importFileInput').value = ''
      // ie 일때 input[type=file] init.
      // var agent = navigator.userAgent.toLowerCase()
      // if ((navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) || (agent.indexOf('msie') !== -1)) {
      //   // document.getElementById('importFileInput').value = ''
      //   // document.getElementById('importFileInput').replaceWith(document.getElementById('importFileInput').cloneNode(true))
      //   // document.getElementById('importFileInput').select()
      //   // document.selection.clear()
      //   document.getElementById('importFileInput').value = ''
      //   document.getElementById('importFileInput').parentNode.replaceChild(
      //     document.getElementById('importFileInput').cloneNode(true),
      //     document.getElementById('importFileInput')
      //   )
      // } else {
      //   document.getElementById('importFileInput').value = ''
      // }
    },
    /**
     * Edit Button click event
     * check된 row가 없는 상태에서 click 시 alert를 띄웁니다.
     */
    clickDisabledEditButton () {
      if (this.$refs.fabManagerGrid.checkedRowCount !== 1) {
        this.$dialog.alert('Check a row to edit Fab')
      }
    }
  },
  data () {
    return {
      fabManagerGrid: null, // Fab Manager Grid 객체
      columns: [], // grid column 배열
      defaultColDef: {
        // flex: 1, // 배율
        minWidth: 100,
        filter: true,
        resizable: true,
        sortable: true
      },
      rowData: [], // grid row data
      collectionViewOptions: {
        groupDescriptions: ['fab']
      }, // grid row group 설정 정보
      fabUseYnList: [
        { fabUseYn: 'Y' },
        { fabUseYn: 'N' }
      ], // fab useYn dataMap 배열
      areaUseYnList: [
        { areaUseYn: 'Y' },
        { areaUseYn: 'N' }
      ], // area useYn dataMap 배열
      eqpModelUseYnList: [
        { eqpModelUseYn: 'Y' },
        { eqpModelUseYn: 'N' }
      ], // EqpModel useYn dataMap 배열
      initValue: {}, // Fab Add/Edit 초기 data
      modalTitle: '', // Modal Title
      fabSaveModal: {
        visible: false
      } // Fab Add/Edit Modal 표시 여부
    }
  }
}
